import Page from "../Common/Page";
import React from "react";
import {
  Input,
  Table,
  Form,
  Button,
  Row,
  Col,
  Select,
  Popconfirm,
  message,
} from "antd";
import { http } from "../Common/http";
import { AuthContext } from "../Auth/Auth";
import moment from "moment";
import { AuthorityLink } from "../Components/AuthorityLink";
import { AuthorityButton } from "../Components/AuthorityButton";
import { Messages } from "../Common/ValidateMessages";
const { Option } = Select;

interface Props {
  isPopup?: boolean;
  defaultId?: string;
  onDataSelect?: (record?: QuestionData) => void;
}
interface QuestionData {
  questionId: string;
  title: string;
  contents: string;
  updatedOn: Date;
}
interface PostSearchData {
  keyword: string;
  fy: string;
}
interface PostDeleteData extends PostSearchData {
  questionId: string;
}

export class QuestionList extends React.Component<Props> {
  static contextType = AuthContext;
  private _page: React.RefObject<Page>;
  private _form: React.RefObject<any>;
  private _columns: any[];
  private _pageSize = 5;

  state = {
    page: 1,
    datas: [],
  };
  constructor(props: any) {
    super(props);
    this._page = React.createRef<Page>();
    this._form = React.createRef();
    if (this.props.isPopup) {
      this._pageSize = 5;
      this._columns = [
        {
          title: <div className="table-title">No</div>,
          key: "no",
          width: "5%",
          render: (value: any, item: QuestionData, index: number) => (
            <span>{(this.state.page - 1) * this._pageSize + index + 1}</span>
          ),
        },
        {
          title: <div className="table-title">問題名</div>,
          dataIndex: "title",
          key: "title",
          width: "15%",
        },
        {
          title: <div className="table-title">内容</div>,
          dataIndex: "contents",
          className: "multip-line-column",
          key: "contents",
          width: "65%",
        },
        {
          title: <div className="table-title">更新日時</div>,
          dataIndex: "updatedOn",
          key: "updatedOn",
          width: "15%",
          render: (value: any, item: QuestionData, index: number) =>
            moment(item.updatedOn).format("YYYY/MM/DD HH:mm:ss"),
        },
        {
          title: "",
          key: "action",
          render: (value: any, item: QuestionData, index: number) => (
            <Button
              type="dashed"
              htmlType="button"
              onClick={() => {
                if (this.props.onDataSelect) this.props.onDataSelect(item);
              }}
            >
              選択
            </Button>
          ),
        },
      ];
    } else {
      this._pageSize = 8;
      this._columns = [
        {
          title: <div className="table-title">No</div>,
          key: "no",
          width: "5%",
          render: (value: any, item: QuestionData, index: number) => (
            <span>{(this.state.page - 1) * this._pageSize + index + 1}</span>
          ),
        },
        {
          title: <div className="table-title">問題名</div>,
          dataIndex: "title",
          key: "title",
          width: "15%",
        },
        {
          title: <div className="table-title">内容</div>,
          dataIndex: "contents",
          className: "multip-line-column",
          key: "contents",
          width: "55%",
        },
        {
          title: <div className="table-title">更新日時</div>,
          dataIndex: "updatedOn",
          key: "updatedOn",
          width: "15%",
          render: (value: any, item: QuestionData, index: number) =>
            moment(item.updatedOn).format("YYYY/MM/DD HH:mm:ss"),
        },
        {
          title: <div className="table-title">編集</div>,
          key: "action",
          width: "5%",
          render: (text: any, record: QuestionData) => (
            <AuthorityLink to={"/QuestionRegist/" + record.questionId}>
              編集
            </AuthorityLink>
          ),
        },
        {
          title: <div className="table-title">削除</div>,
          key: "action",
          width: "5%",
          render: (text: any, record: QuestionData) => (
            <Popconfirm
              title={Messages["CON-025"]}
              okText="はい"
              cancelText="いいえ"
              onConfirm={() => this.onDelete(record)}
            >
              <AuthorityButton
                functioncode="FU-64"
                authority="2"
                type="primary"
                htmlType="button"
              >
                削除
              </AuthorityButton>
            </Popconfirm>
          ),
        },
      ];
    }
  }

  async componentDidMount() {
    const { defaultId } = this.props;
    if (defaultId !== undefined && defaultId != null && defaultId.length > 0) {
      try {
        const result = await http<QuestionData>({
          path: "/Question/" + defaultId,
          method: "get",
          accessToken: this.context.accessToken,
        });
        if (result.ok) {
          this.setState({
            datas: [result.body],
          });
          // if (this.props.onDataSelect) this.props.onDataSelect(result.body);
        }
      } catch (error) {
        console.log(error);
      }
    }
  }

  onFinish = async (values: any) => {
    // console.log("Success:", values);
    try {
      this._page.current?.setState({ isPageLoading: true });
      const searchData: PostSearchData = {
        keyword: values.keyword ? values.keyword : null,
        fy: values.fy ? values.fy : null,
      };
      const result = await http<QuestionData[], PostSearchData>({
        path: "/Question/search",
        method: "post",
        body: searchData,
        accessToken: this.context.accessToken,
      });
      if (result.ok && result.body) {
        this.setState({
          datas: result.body,
        });
        this._page.current?.setState({ isPageLoading: false });
      } else {
        this._page.current?.setState({ isPageLoading: false });
      }
    } catch (error) {
      console.log(error);
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  // 削除ボタン押す
  onDelete = async (question: QuestionData) => {
    try {
      this._page.current?.setState({ isPageLoading: true });
      const keyword = this._form.current.getFieldValue("keyword");
      const fy = this._form.current.getFieldValue("fy");
      const postData: PostDeleteData = {
        questionId: question.questionId,
        keyword: keyword ? keyword : null,
        fy: fy ? fy : null,
      };
      const result = await http<QuestionData[], PostDeleteData>({
        path: "/Question/delete",
        method: "post",
        body: postData,
        accessToken: this.context.accessToken,
      });
      if (result.ok && result.body) {
        this.setState({
          datas: result.body,
        });
      } else {
        message.error(Messages["ERR-076"]);
      }
      this._page.current?.setState({ isPageLoading: false });
    } catch (error) {
      console.log(error);
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  render(): React.ReactNode {
    return (
      <Page
        title={this.props.isPopup ? undefined : "問題一覧"}
        ref={this._page}
      >
        <div className="data_content">
          <Form
            colon={false}
            className={this.props.isPopup ? "" : "search_form"}
            name="searchForm"
            onFinish={this.onFinish}
            layout={"inline"}
            initialValues={{ fy: "1" }}
            ref={this._form}
          >
            <Row>
              <Col span={9}>
                <Form.Item label="フリーワード" name="keyword">
                  <Input style={{ width: "50%" }} maxLength={20} />
                </Form.Item>
              </Col>
              <Col span={9}>
                <Form.Item label="作成年度" name="fy">
                  <Select allowClear={true} style={{ width: 160 }}>
                    <Option key="1" value="1">
                      今年度のみ
                    </Option>
                    <Option key="2" value="2">
                      過去年度を含む
                    </Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    検索
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <Row style={{ width: "100%" }}>
            <Col span={24}>
              <Table
                rowKey={(record: QuestionData) => record.questionId}
                bordered
                size={"small"}
                columns={this._columns}
                dataSource={this.state.datas}
                // scroll={{ y: 720 }}
                onRow={(record, rowIndex) => {
                  return {
                    onClick: (event) => {}, // click row
                    onDoubleClick: (event) => {
                      if (this.props.onDataSelect)
                        this.props.onDataSelect(record);
                    }, // double click row
                    onContextMenu: (event) => {}, // right button click row
                    onMouseEnter: (event) => {}, // mouse enter row
                    onMouseLeave: (event) => {}, // mouse leave row
                  };
                }}
                pagination={{
                  size: "small",
                  pageSize: this._pageSize,
                  position: ["topLeft"],
                  showTotal: (total) => {
                    return (
                      <ul className="resultCount">
                        <li className="grey">
                          対象<span>{total}</span>
                        </li>
                      </ul>
                    );
                  },
                  onChange: (current) => this.setState({ page: current }),
                }}
              />
            </Col>
          </Row>
        </div>
      </Page>
    );
  }
}
